import { startRegisterUserInterest } from '../actions/userInterestActions';

export const registerPanelViewInterest = (dispatch, moduleKey, record) => {
  if (!record || !record.id) return;
  dispatch(
    startRegisterUserInterest({
      event_type: 'panel_view',
      sourceModule: moduleKey,
      targetModule: moduleKey,
      originIds: [record.id],
      targetId: record.id,
      bridge_kind: 'panel',
    })
  );
};

export const registerCompareInterest = (dispatch, moduleKey, originIds) => {
  const ids = (originIds || []).filter((n) => n > 0);
  if (!ids.length) return;
  dispatch(
    startRegisterUserInterest({
      event_type: 'compare',
      sourceModule: moduleKey,
      targetModule: moduleKey,
      originIds: ids,
      originId: ids[0],
      bridge_kind: 'compare',
    })
  );
};

export const buildLoginContext = () => {
  try {
    return {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locale: typeof navigator !== 'undefined' ? navigator.language : null,
      languages: typeof navigator !== 'undefined' ? navigator.languages : null,
      platform: typeof navigator !== 'undefined' ? navigator.platform : null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      screen_width: typeof window !== 'undefined' ? window.screen && window.screen.width : null,
      screen_height: typeof window !== 'undefined' ? window.screen && window.screen.height : null,
    };
  } catch (_e) {
    return {};
  }
};
